const Checkbox = ({ checked, onChange, className = "" }) => (
  <div
    onClick={(e) => {
      e.stopPropagation();
      onChange(!checked);
    }}
    className={`w-4 h-4 min-w-4 min-h-4 rounded-[5px] border-2 border-primary-500 cursor-pointer flex items-center justify-center shrink-0 box-border ${
      checked ? "bg-primary-500" : "bg-white"
    } ${className}`}
  >
    {checked && (
      <svg width="9" height="7" viewBox="0 0 9 7" fill="none">
        <path
          d="M1 3.5L3.5 6L8 1"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </div>
);

export default Checkbox;
